export interface PaymentReturnDetails {
  receivedMinor: number;
  outstandingMinor: number;
  payments: Array<{ status: string }>;
}

export function paymentReturnMessage(result: string | null, details: PaymentReturnDetails | null, booking = false): string {
  if (result === 'cancelled') {
    return 'The payment was cancelled. This return has not recorded a payment.';
  }
  if (details && details.outstandingMinor === 0 && details.receivedMinor > 0) {
    return booking ? 'This booking is paid in full.' : 'This quotation is paid in full.';
  }
  if (result !== 'returned') return '';
  const waiting = !details
    || details.payments.some((item) => item.status === 'pending')
    || details.receivedMinor <= 0;
  if (waiting) {
    return 'PayFast has returned you to the studio. This payment is confirmed only after the server verifies it.';
  }
  return 'Payment received.';
}

export function paymentAwaitingVerification(details: PaymentReturnDetails | null): boolean {
  return Boolean(details && details.payments.some((item) => item.status === 'pending'));
}
